import { COLORS, Ic, ICONS, Mark, Wordmark } from "@/lib/theme";
import BackHomeBar from "@/components/BackHomeBar";

export default function More({ member, onOpenDetail, onOpenAI, onOpenAdmin, onOpenProfile, onLogout, onHome, isAdmin }) {
  const items = [
    ["My Profile & Family", ICONS.people, "profile"],
    ["Welcome to LinkShul", ICONS.info, "welcome"],
    ["Our Team", ICONS.people, "team"],
    ["History of LinkShul", ICONS.book, "history"],
    ["Security", ICONS.shield, "security"],
    ["Contact Us", ICONS.phone, "contact"],
    ["AI Assistant", ICONS.chat, "ai"],
    ["My Donations", ICONS.heart, "donations"],
    ["Credits", ICONS.sparkles, "credits"],
  ];
  if (isAdmin) items.splice(0, 0, ["Admin Portal", ICONS.shield, "admin"]);
  if (member) items.push(["Sign Out", ICONS.logout, "logout"]);
  else items.push(["Sign In", ICONS.user, "signin"]);

  const handle = (key) => {
    if (key === "ai") return onOpenAI();
    if (key === "admin") return onOpenAdmin();
    if (key === "profile") return onOpenProfile();
    if (key === "logout") return onLogout();
    if (key === "signin") return onLogout();
    onOpenDetail({ title: items.find(i => i[2] === key)[0], body: key });
  };

  return (
    <div className="ls-scroll" data-testid="more-screen" style={{ paddingBottom: 100 }}>
      <BackHomeBar title="More" onHome={onHome} />
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "24px 0 8px" }}>
        <img src="/assets/linkshul-logo.png" alt="LinkShul" style={{ height: 100, borderRadius: 16, boxShadow: "0 12px 30px rgba(91,42,130,0.25)" }} />
        <div style={{ marginTop: 12 }}>
          <Wordmark scale={1} />
        </div>
        {member && (
          <div style={{ marginTop: 12, background: COLORS.lilac, padding: "6px 14px", borderRadius: 20, fontWeight: 700, fontSize: 13, color: COLORS.purple }}>
            {member.first_name} {member.last_name}
          </div>
        )}
      </div>
      <div style={{ padding: "18px 18px 0" }}>
        {items.map(([t, d, key]) => (
          <button
            key={key}
            data-testid={`more-${key}`}
            onClick={() => handle(key)}
            className="no-tap-highlight"
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 16,
              padding: "16px 8px",
              background: "none",
              border: "none",
              borderBottom: "1px solid " + COLORS.border,
              cursor: "pointer",
              fontFamily: "'Nunito', sans-serif",
              fontWeight: 700,
              fontSize: 16,
              color: COLORS.ink,
              textAlign: "left",
            }}
          >
            <Ic d={d} color={COLORS.plum} size={22} />
            <span style={{ flex: 1 }}>{t}</span>
            <Ic d={ICONS.arrow} color="#c3b6cd" size={18} />
          </button>
        ))}
        <div style={{ textAlign: "center", color: "#a99bb3", fontWeight: 700, fontSize: 11.5, marginTop: 22, lineHeight: 1.7 }} data-testid="app-footer">
          <div>LinkShul · Version 1.0.0</div>
          <div style={{ marginTop: 6 }}>© LinkShul. All Rights Reserved.</div>
          <div style={{ color: "#8f7a9c" }}>Powered by Farrell Berson</div>
        </div>
      </div>
    </div>
  );
}
